module.exports = "https://statics.teams.cdn.live.net/hashedassets-launcher/illustration.f5e373643a85f31cfda35559ab09c960.svg";